export default function reducer(
  state = {
    type: 'default',
    fields: {
      id: null,
      template: {},
      name: null,
      type: {},
      hours: 0,
      description: null,
      color: null,
      workstreamLead: {},
      isTemplate: false,
      details: [],
      users: [],
    },
  },
  action
) {
  switch (action.type) {
    case 'UPDATE_WORKSTREAM_FORM_TYPE': {
      return {
        ...state,
        type: action.formType,
      };
    }

    case 'UPDATE_WORKSTREAM_FORM_FIELD': {
      return {
        ...state,
        fields: {
          ...state.fields,
          [action.field.id]: action.field.value,
        },
      };
    }

    case 'UPDATE_WORKSTREAM_FORM_FIELDS': {
      return {
        ...state,
        fields: {
          ...state.fields,
          ...action.fields,
        },
      };
    }

    default: {
      return state;
    }
  }
}
